import React from 'react';

import {
  Button,
  Dropdown,
} from 'react-bootstrap';
import styled from 'styled-components';

import { 
  Popover,
} from 'antd';

// ----------------------------------------------------------------------

const StyledDiv = styled.div<any>`
  ${(props: any) => {
    if(props.width){
      return 'min-width: ' + props.width + ';'
    } else {
      return 'min-width: 150px;'
    } 
  }}

  .list-unstyled {
    .dropdown-item {
      align-items: center;
      display: inline-flex;

      svg {
        position: relative;
        width: 18px;
        height: 18px;
        top: -2px;
      }
    }
  }
`;


const DefaultPopup = React.forwardRef(({ disabled, icon, text, children, width }: any, ref: any) => {
  const [open, setOpen] = React.useState(false);


  React.useImperativeHandle(
    ref,
    () => ({
      hide() {
        setOpen(false);
      },
    }),
  );


  return <Popover
    open={open}
    onOpenChange={(newOpen: boolean) => {
      setOpen(newOpen);
    }}

    content={<StyledDiv width={width} style={{ minWidth: width }}>{children}</StyledDiv>}
    arrow={false}
    placement="bottomRight"
    trigger="click"
  >
    <Button
      variant={'custom-outlined'}
      size='sm'
      tabIndex={-1}
      disabled={disabled}
    >
      {icon}{(text && text != '') && <span className='ps-2'>{text}</span>}
    </Button>
  </Popover>
})

export default DefaultPopup